var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: !_vm.item.hidden,
          expression: "!item.hidden",
        },
      ],
      staticClass: "custom-navbar-item",
      class: {
        disabled: _vm.item.disabled,
        active: _vm.item.active,
        "input-within": _vm.inputWithin,
      },
      style: { flex: _vm.item.flexStyle, order: _vm.item.order },
      attrs: { role: "listitem", "data-name": _vm.item.name },
    },
    [
      _vm.item.href
        ? _c(
            "CustomNavbarLink",
            {
              staticClass: "main-content",
              attrs: {
                "new-tab": _vm.newTab,
                href: !_vm.item.active && !_vm.item.touch && _vm.item.href,
              },
              on: {
                mouseover: function ($event) {
                  if ($event.target !== $event.currentTarget) return null
                  return _vm.requestPopup()
                },
              },
            },
            [
              typeof _vm.item.content === "string"
                ? [_vm._v("\n      " + _vm._s(_vm.item.content) + "\n    ")]
                : _c(_vm.item.content, {
                    tag: "component",
                    attrs: { item: _vm.item },
                  }),
            ],
            2
          )
        : _c(
            "div",
            {
              staticClass: "main-content",
              on: {
                click: function ($event) {
                  !_vm.item.active &&
                    !_vm.item.touch &&
                    _vm.item.clickAction &&
                    _vm.item.clickAction($event)
                },
              },
            },
            [
              typeof _vm.item.content === "string"
                ? [_vm._v("\n      " + _vm._s(_vm.item.content) + "\n    ")]
                : _c(_vm.item.content, {
                    tag: "component",
                    attrs: { item: _vm.item },
                  }),
            ],
            2
          ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.item.active,
              expression: "!item.active",
            },
          ],
          staticClass: "notify-count",
        },
        [
          _vm.item.notifyCount > 0
            ? [_vm._v("\n      " + _vm._s(_vm.item.notifyCount) + "\n    ")]
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "popupContainer",
          staticClass: "popup-container",
          on: {
            focusin: function ($event) {
              return _vm.toggleInputWithin($event, true)
            },
            focusout: function ($event) {
              return _vm.toggleInputWithin($event, false)
            },
          },
        },
        [
          _vm.item.popupContent
            ? _c(
                "div",
                { staticClass: "popup", class: _vm.popupClasses(_vm.item) },
                [
                  _vm.item.requestedPopup
                    ? _c(_vm.item.popupContent, {
                        ref: "popup",
                        tag: "component",
                        attrs: {
                          container: _vm.$refs.popupContainer,
                          item: _vm.item,
                        },
                      })
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "active-bar" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }